import { ArticleParagraph1 } from '@cian/ui-kit';
import { FC, ReactNode } from 'react';

interface INewbuildingInfoProps {
  name: ReactNode;
  details?: string | null;
}

export const NewbuildingInfo: FC<INewbuildingInfoProps> = ({ name, details }) => {
  return (
    <ArticleParagraph1 as="div">
      {name}
      {details && `, ${details}`}
    </ArticleParagraph1>
  );
};
